/* eslint semi:0 */
import AnalyticsBaseService from 'services/analytics/analyticsBaseService'
import networkProvider from 'providers/networkProvider'
import pageDataObject from 'application/pageDataObject'
import userStore from 'stores/userStore'
import { queryString, } from 'utils/window'
import { scrollPercent, body, referringDomain, } from 'utils/dom'
import ua from 'utils/ua'
import analyticsActions from 'actions/analyticsActions'

const TIME_ON_PAGE_INTERVALS_SEC = [5, 10, 15, 30, 45, 60, 90]

class BigQueryProxyService extends AnalyticsBaseService {

  constructor(options = {}){
    super(options)
  }

  get className() { return "BigQueryProxyService" }

  initTimeOnPageIntervals() {
    this.timeOnPageIntervalIds = this.timeOnPageIntervalIds || []
    for (let timeoutId of this.timeOnPageIntervalIds) {
      clearTimeout(timeoutId)
    }
    for (let timeInterval of TIME_ON_PAGE_INTERVALS_SEC) {
      let timeoutId = setTimeout(analyticsActions.timeOnPageInterval.part(timeInterval), timeInterval * 1000)
      this.timeOnPageIntervalIds.push(timeoutId)
    }
  }

  pageViewed() {
    this.pageviewTime = new Date().getTime()
    this.trackEvent('pageview')
    // this.initTimeOnPageIntervals()
  }

  scrollAnchorReached(action) {
    this.reportOnce(action, () => {
      this.trackEvent('scroll_anchor_reached', { scroll_anchor: action.payload.anchor })  // eslint-disable-line camelcase
    })
  }

  timeOnPageInterval(action) {
    this.reportOnce(action, () => {
      this.trackEvent('time_interval', { time_on_page: action.timeOnPage * 1000 })  // eslint-disable-line camelcase
    })
  }

  get contentHeight() {
    return this.pageContentHeight || (this.pageContentHeight = body.clientHeight)
  }

  get eventData() {
    /* eslint-disable camelcase */
    return {
      pageview_uid: this.store.pageviewUid,
      uid: (userStore.state.id || userStore.guestId).toString(),
      affiliate_id: queryString.a_aid,
      referring_domain: referringDomain(),
      utm_source: queryString.utm_source,
      utm_medium: queryString.utm_medium,
      utm_campaign: queryString.utm_campaign,
      locale: pageDataObject.get('page.locale'),
      content_height: this.contentHeight,
      viewport_height: ua.viewport.height,
      platform: ua.platform,
      user_agent: ua.ua,
      content_scrolled_percent: scrollPercent(),
      time_on_page: new Date().getTime() - this.pageviewTime,
    }
    /* eslint-enable */
  }

  get postPageData() {
    /* eslint-disable camelcase */
    return {
      post_id: pageDataObject.get('post.id'),
      post_template: pageDataObject.get('post.template'),
      post_layout: pageDataObject.get('post.layout'),
      post_author_id: pageDataObject.get('post.author.id'),
      main_media: pageDataObject.postMainMediaType,
      body_media: pageDataObject.postBodyMediaTypes.join(','),
    }
    /* eslint-enable */
  }

  trackEvent(eventName, data) {
    let eventData = { ...this.eventData, ...this.postPageData, ...data }
    eventData.event_name = eventName // eslint-disable-line camelcase
    this.logAnalytics(eventName, eventData)
    networkProvider.safeRequest({
      method: 'GET',
      url: `${ pageDataObject.get('config.analytics_bq.proxy') }/user_behaviour${networkProvider.jsonToQueryString(eventData)}`,
    })
  }

}

export default BigQueryProxyService


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/analytics/bigQueryProxyService.js